export const header = {
  invoke: {
    src: 'watchHeaderActions',
  },
  initial: 'idle',
  states: {
    idle: {
      on: {
        WH_HEADER_INITIALIZED: {
          actions: 'setHeaderInitialized',
        },
        VIEW_PARTIAL_EVENT_CALLED: {
          actions: 'trackPartialEvent',
        },
        VIEW_FEEDBACK_EVENT_CALLED: {
          actions: 'openUsabilla',
        },
        GAMING_USER_DETAILS_FETCHED: {
          actions: [
            'updateUserTrackingInfo',
            'saveInfoAccountInfo',
            'trackPendingAccountEvents',
          ],
        },
        VIEW_HAMBURGER_MENU_CLICK: {
          actions: ['trackHamburgerClick', 'nav_HANDLE_CHANGE'],
        },
      },
    },
  },
};
